import {NgModule} from "@angular/core";
import {DepositPaymentMethodModal} from "./deposit-payment-method-modal";
import {IonicPageModule} from "ionic-angular";

@NgModule({
  declarations: [DepositPaymentMethodModal],
  imports: [IonicPageModule.forChild(DepositPaymentMethodModal)],
  entryComponents: [DepositPaymentMethodModal]
})
export class DepositPaymentMethodModalModule {}



// WEBPACK FOOTER //
// ./src/pages/meeting/deposit-payment-method-modal/deposit-payment-method-modal.module.ts